import React from "react";
import { useValidSubscription } from "../../../../hooks/useValidSubscription";

export const LOCKED_SCORE_LABEL = "Score available to subscribers";

// The API returns null scores to non-subscribers; true when there is no score to show.
export const isScoreMissing = (score: unknown): boolean =>
  score === null || score === undefined || `${score}`.trim() === "";

// Small lock rendered in place of a score that was withheld by the API.
// Subscribers always get scores, so for them a missing score just renders nothing (as before).
const LockedScore = ({ className = "h-[1em] w-[1em]" }: { className?: string }) => {
  const hasValidSubscription = useValidSubscription();
  if (hasValidSubscription) return null;

  return (
    <span
      className="inline-flex items-center justify-center align-middle"
      title={LOCKED_SCORE_LABEL}
      role="img"
      aria-label={LOCKED_SCORE_LABEL}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    </span>
  );
};

export default LockedScore;
